type ZoomIconProps = {
  size?: number
}

export function PlusIcon({ size = 24 }: ZoomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18.6667 18.6667"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M18.6667 9.33333C18.6667 9.53961 18.5847 9.73745 18.4389 9.88331C18.293 10.0292 18.0952 10.1111 17.8889 10.1111H10.1111V17.8889C10.1111 18.0952 10.0292 18.293 9.88331 18.4389C9.73745 18.5847 9.53961 18.6667 9.33333 18.6667C9.12705 18.6667 8.92922 18.5847 8.78336 18.4389C8.6375 18.293 8.55556 18.0952 8.55556 17.8889V10.1111H0.777778C0.571498 10.1111 0.373668 10.0292 0.227806 9.88331C0.0819444 9.73745 0 9.53961 0 9.33333C0 9.12705 0.0819444 8.92922 0.227806 8.78336C0.373668 8.6375 0.571498 8.55556 0.777778 8.55556H8.55556V0.777778C8.55556 0.571498 8.6375 0.373668 8.78336 0.227806C8.92922 0.0819444 9.12705 0 9.33333 0C9.53961 0 9.73745 0.0819444 9.88331 0.227806C10.0292 0.373668 10.1111 0.571498 10.1111 0.777778V8.55556H17.8889C18.0952 8.55556 18.293 8.6375 18.4389 8.78336C18.5847 8.92922 18.6667 9.12705 18.6667 9.33333Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function MinusIcon({ size = 24 }: ZoomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 -8.66667 18.6667 18.6667"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M18.6667 0.666667C18.6667 0.843478 18.5847 1.01305 18.4389 1.13807C18.293 1.2631 18.0952 1.33333 17.8889 1.33333H0.777778C0.571498 1.33333 0.373668 1.2631 0.227806 1.13807C0.0819444 1.01305 0 0.843478 0 0.666667C0 0.489856 0.0819444 0.320287 0.227806 0.195262C0.373668 0.070238 0.571498 0 0.777778 0H17.8889C18.0952 0 18.293 0.070238 18.4389 0.195262C18.5847 0.320287 18.6667 0.489856 18.6667 0.666667Z"
        fill="currentColor"
      />
    </svg>
  )
}
